(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["judy-product-panel"] && !Shopify.designMode) return;
  try {
    class JudyPdpPanel extends HTMLElement {
    connectedCallback() {
      this.initializeDescriptionAccordions();
      this.initializeAccordionAnimations();
      this.initializeOptionScrollers();

      const data = this.querySelector('[data-judy-variants]');
      if (!(data instanceof HTMLScriptElement)) return;

      try {
        this.variants = JSON.parse(data.textContent || '[]');
      } catch {
        this.variants = [];
      }

      if (!this.variants.length) return;

      this.colorIndex = Number(this.dataset.colorOptionIndex);
      this.sizeIndex = Number(this.dataset.sizeOptionIndex);
      this.packagingIndex = Number(this.dataset.packagingOptionIndex);
      const initialVariant = this.initialVariant();
      this.currentColor = this.optionValue(initialVariant, this.colorIndex, '__default');
      this.currentPackaging = this.optionValue(initialVariant, this.packagingIndex, '');
      this.quantities = new Map();
      this.activeVariantId = String(initialVariant.id);
      this.quantities.set(this.activeVariantId, 1);
      this.packagingUnavailable = false;
      this.bindEvents();
      this.refreshPackagingAvailability();
      this.initializeWishlist();
      this.update();
    }

    disconnectedCallback() {
      this.optionScrollerObservers?.forEach((observer) => observer.disconnect());
      this.optionScrollerResizeHandlers?.forEach((handler) => window.removeEventListener('resize', handler));
    }

    initializeDescriptionAccordions() {
      const container = this.querySelector('[data-judy-description-accordions]');
      const source = this.querySelector('[data-judy-description-source]');
      if (!(container instanceof HTMLElement) || !(source instanceof HTMLElement) || container.dataset.initialized === 'true') return;

      container.dataset.initialized = 'true';
      const groups = [];
      const preamble = [];
      let currentGroup;

      this.descriptionContentNodes(source).forEach((node) => {
        const title = this.descriptionHeading(node);
        if (title) {
          currentGroup = { title, nodes: [] };
          if (!groups.length && preamble.length) currentGroup.nodes.push(...preamble);
          groups.push(currentGroup);
          return;
        }

        const clone = node.cloneNode(true);
        if (currentGroup) currentGroup.nodes.push(clone);
        else preamble.push(clone);
      });

      const populatedGroups = groups.filter((group) => this.descriptionNodesHaveText(group.nodes));
      if (!populatedGroups.length) return;

      const fragment = document.createDocumentFragment();
      populatedGroups.forEach((group) => {
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        const title = document.createElement('span');
        const content = document.createElement('div');

        title.textContent = group.title;
        summary.append(title);
        content.className = 'judy-pdp-panel__accordion-content judy-pdp-panel__accordion-content--product rte';
        content.append(...group.nodes);
        details.append(summary, content);
        fragment.append(details);
      });

      container.replaceChildren(fragment);
    }

    descriptionContentNodes(source) {
      const nodes = [];
      const visit = (node) => {
        if (this.descriptionHeading(node)) {
          nodes.push(node);
          return;
        }

        if (this.descriptionContainerHasHeading(node)) {
          Array.from(node.childNodes).forEach(visit);
          return;
        }

        nodes.push(node);
      };

      Array.from(source.childNodes).forEach(visit);
      return nodes;
    }

    descriptionContainerHasHeading(node) {
      if (!(node instanceof HTMLElement) || !node.matches('div, section, article')) return false;
      return Array.from(node.childNodes).some((child) => {
        return Boolean(this.descriptionHeading(child)) || this.descriptionContainerHasHeading(child);
      });
    }

    descriptionHeading(node) {
      if (!(node instanceof HTMLElement)) return '';
      if (/^H[1-6]$/.test(node.tagName)) return node.textContent?.trim() || '';
      if (node.matches('strong, b')) return node.textContent?.trim() || '';

      const boldElements = Array.from(node.querySelectorAll('strong, b'));
      if (boldElements.length !== 1) return '';

      const boldText = boldElements[0].textContent?.trim() || '';
      const nodeText = node.textContent?.trim() || '';
      return boldText && boldText === nodeText ? boldText : '';
    }

    descriptionNodesHaveText(nodes) {
      return nodes.some((node) => Boolean(node.textContent?.trim()));
    }

    initializeAccordionAnimations() {
      const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

      this.querySelectorAll('.judy-pdp-panel__accordions details').forEach((details) => {
        const summary = details.querySelector(':scope > summary');
        const content = details.querySelector(':scope > .judy-pdp-panel__accordion-content');
        if (!(summary instanceof HTMLElement) || !(content instanceof HTMLElement) || details.dataset.animated === 'true') return;

        details.dataset.animated = 'true';
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          if (details.dataset.animating === 'true') return;

          const opening = !details.open;
          if (reduceMotion || typeof content.animate !== 'function') {
            details.open = opening;
            return;
          }

          details.dataset.animating = 'true';
          if (opening) details.open = true;
          else details.classList.add('is-closing');

          const height = `${content.scrollHeight}px`;
          const animation = content.animate(
            opening
              ? [{ height: '0px', opacity: 0 }, { height, opacity: 1 }]
              : [{ height, opacity: 1 }, { height: '0px', opacity: 0 }],
            { duration: 240, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
          );

          animation.addEventListener(
            'finish',
            () => {
              if (!opening) details.open = false;
              details.classList.remove('is-closing');
              delete details.dataset.animating;
            },
            { once: true }
          );
        });
      });
    }

    initializeOptionScrollers() {
      this.optionScrollerObservers = [];
      this.optionScrollerResizeHandlers = [];

      this.querySelectorAll('[data-judy-option-scroller]').forEach((shell) => {
        const track = shell.querySelector('[data-judy-options]');
        const previous = shell.querySelector('[data-judy-option-scroll="-1"]');
        const next = shell.querySelector('[data-judy-option-scroll="1"]');
        if (!(track instanceof HTMLElement) || !(previous instanceof HTMLButtonElement) || !(next instanceof HTMLButtonElement)) return;
        if (shell.dataset.initialized === 'true') return;

        shell.dataset.initialized = 'true';
        const update = () => {
          const scrollable = track.scrollWidth - shell.clientWidth > 1;
          shell.classList.toggle('is-scrollable', scrollable);
          previous.hidden = !scrollable;
          next.hidden = !scrollable;

          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          previous.disabled = !scrollable || track.scrollLeft <= 1;
          next.disabled = !scrollable || track.scrollLeft >= maximum - 1;
        };
        const move = (direction) => {
          const distance = Math.max(track.clientWidth * 0.8, 54);
          track.scrollBy({ left: direction * distance, behavior: 'smooth' });
        };

        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', update, { passive: true });

        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(() => requestAnimationFrame(update));
          observer.observe(shell);
          this.optionScrollerObservers.push(observer);
        } else {
          window.addEventListener('resize', update, { passive: true });
          this.optionScrollerResizeHandlers.push(update);
        }

        document.fonts?.ready.then(update);
        requestAnimationFrame(update);
      });
    }

    initialVariant() {
      const id = String(this.dataset.currentVariantId || '');
      return this.variants.find((variant) => String(variant.id) === id) || this.variants.find((variant) => variant.available) || this.variants[0];
    }

    optionValue(variant, index, fallback) {
      if (!variant || index < 0) return fallback;
      return variant.options?.[index] ?? fallback;
    }

    colorButtons() {
      return Array.from(this.querySelectorAll('[data-judy-color]'));
    }

    optionButtons() {
      return Array.from(this.querySelectorAll('[data-judy-option-index][data-judy-option-value]'));
    }

    packagingButtons() {
      return Array.from(this.querySelectorAll('[data-judy-packaging-value]'));
    }

    variantForOptions(options) {
      return this.variants.find((variant) => {
        return variant.options?.length === options.length && variant.options.every((option, index) => option === options[index]);
      });
    }

    firstAvailableVariant(preferredIndex = -1, preferredValue = '') {
      if (preferredIndex >= 0 && preferredValue !== '') {
        const matchingVariant = this.variants.find((variant) => {
          return variant.available && variant.options?.[preferredIndex] === preferredValue;
        });
        if (matchingVariant) return matchingVariant;
      }
      return this.variants.find((variant) => variant.available) || this.variants[0];
    }

    activeVariant() {
      return this.variants.find((variant) => String(variant.id) === String(this.activeVariantId)) || this.initialVariant();
    }

    selectVariant(variant) {
      if (!variant?.available) return false;
      this.activeVariantId = String(variant.id);
      this.currentColor = this.optionValue(variant, this.colorIndex, '__default');
      this.currentPackaging = this.optionValue(variant, this.packagingIndex, '');
      this.quantities.clear();
      this.quantities.set(this.activeVariantId, 1);
      this.packagingUnavailable = false;
      return true;
    }

    variantForOption(index, value) {
      const active = this.activeVariant();
      if (!active) return undefined;
      const options = [...active.options];
      options[index] = value;
      const exact = this.variantForOptions(options);
      if (exact?.available) return exact;
      return this.firstAvailableVariant(index, value);
    }

    refreshPackagingAvailability() {
      this.packagingUnavailable = false;
    }

    setPackaging(packaging) {
      if (this.packagingIndex < 0 || !packaging) return;
      const variant = this.variantForOption(this.packagingIndex, packaging);
      if (!this.selectVariant(variant)) return;
      this.update();
    }

    bindEvents() {
      this.colorButtons().forEach((button) => {
        button.addEventListener('click', () => {
          const variant = this.firstAvailableVariant(this.colorIndex, button.dataset.judyColor || '__default');
          if (!this.selectVariant(variant)) return;
          this.update();
        });
      });

      this.optionButtons().forEach((button) => {
        button.addEventListener('click', () => {
          const optionIndex = Number(button.dataset.judyOptionIndex);
          const optionValue = button.dataset.judyOptionValue || '';
          const variant = this.variantForOption(optionIndex, optionValue);
          if (!this.selectVariant(variant)) return;
          this.update();
        });
      });

      this.packagingButtons().forEach((button) => {
        button.addEventListener('click', () => this.setPackaging(button.dataset.judyPackagingValue || ''));
      });

      this.querySelectorAll('[data-judy-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => this.changeQuantity(Number(button.dataset.judyQuantityChange)));
      });

      this.querySelector('[data-judy-add-to-cart]')?.addEventListener('click', () => this.addToCart());
      this.querySelectorAll('[data-judy-share]').forEach((button) => button.addEventListener('click', () => this.share()));
      this.querySelectorAll('[data-judy-wishlist]').forEach((button) => button.addEventListener('click', () => this.toggleWishlist()));
    }

    changeQuantity(delta) {
      if (this.dataset.busy === 'true') return;
      const variant = this.activeVariant();
      if (!variant?.available) return;
      const id = String(variant.id);
      const current = this.quantities.get(id) || 0;
      const maximum = Number.isFinite(Number(variant.max)) && Number(variant.max) > 0 ? Number(variant.max) : 999;
      this.quantities.set(id, Math.max(0, Math.min(maximum, current + delta)));
      this.refreshPackagingAvailability();
      this.update();
    }

    selectedItems() {
      const active = this.activeVariant();
      const quantity = active ? this.quantities.get(String(active.id)) || 0 : 0;
      if (!active?.available || quantity <= 0) return [];
      return [{ id: Number(active.id), quantity }];
    }

    update() {
      const active = this.activeVariant();
      const activeId = active ? String(active.id) : '';

      this.colorButtons().forEach((button) => {
        button.setAttribute('aria-pressed', String((button.dataset.judyColor || '__default') === this.currentColor));
      });

      this.optionButtons().forEach((button) => {
        const optionIndex = Number(button.dataset.judyOptionIndex);
        const optionValue = button.dataset.judyOptionValue || '';
        const variant = this.variantForOption(optionIndex, optionValue);
        const isActive = Boolean(active && active.options?.[optionIndex] === optionValue);
        button.disabled = !variant?.available;
        button.classList.toggle('is-selected', isActive);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
        const count = button.querySelector('[data-judy-option-count]');
        if (count) {
          const quantity = isActive ? this.quantities.get(activeId) || 0 : 0;
          count.textContent = quantity > 0 ? String(quantity) : '';
          count.hidden = quantity <= 0;
        }
      });

      this.packagingButtons().forEach((button) => {
        const value = button.dataset.judyPackagingValue || '';
        const selected = Boolean(active && active.options?.[this.packagingIndex] === value);
        const variant = this.variantForOption(this.packagingIndex, value);
        button.disabled = !variant?.available;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });

      const output = this.querySelector('[data-judy-quantity]');
      if (output) output.textContent = String(active ? this.quantities.get(activeId) || 0 : 0);

      const price = this.querySelector('[data-judy-price]');
      if (price && active?.price) price.textContent = active.price;

      const priceContainer = this.querySelector('[data-judy-price-container]');
      const comparePrice = this.querySelector('[data-judy-compare-price]');
      const comparePriceValue = this.querySelector('[data-judy-compare-price-value]');
      const isDiscounted = Boolean(active?.compareAtPrice);
      if (priceContainer) priceContainer.classList.toggle('is-discounted', isDiscounted);
      if (comparePrice) comparePrice.hidden = !isDiscounted;
      if (comparePriceValue && isDiscounted) comparePriceValue.textContent = active.compareAtPrice;

      this.dataset.packagingUnavailable = String(this.packagingUnavailable);
      const disabled = this.selectedItems().length === 0 || this.dataset.busy === 'true' || this.packagingUnavailable;
      const addButton = this.querySelector('[data-judy-add-to-cart]');
      if (addButton) addButton.disabled = disabled;
      this.querySelectorAll('[data-judy-quantity-change]').forEach((button) => {
        button.disabled = this.dataset.busy === 'true' || !active?.available;
      });

      if (this.packagingUnavailable && this.dataset.busy !== 'true') {
        this.setStatus(this.dataset.packagingUnavailableMessage || this.dataset.errorMessage || '');
      }

      if (activeId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', activeId);
        history.replaceState({}, '', url.toString());
      }
    }

    setBusy(busy) {
      this.dataset.busy = String(busy);
      this.update();
    }

    setStatus(message) {
      const status = this.querySelector('[data-judy-status]');
      if (status) status.textContent = message || '';
    }

    async addToCart() {
      const items = this.selectedItems();
      if (!items.length || this.dataset.busy === 'true') return;

      this.setBusy(true);
      this.setStatus('');

      try {
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((element) => element.dataset.sectionId)
          .filter(Boolean);
        const payload = { items };
        if (sectionIds.length) {
          payload.sections = sectionIds.join(',');
          payload.sections_url = window.location.pathname;
        }

        const response = await fetch(this.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add items');

        const cartResponse = await fetch(this.dataset.cartUrl || '/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: this.id,
              data: {
                source: 'judy-pdp-panel',
                productId: this.dataset.productId,
                itemCount: items.reduce((sum, item) => sum + item.quantity, 0),
                sections: result.sections,
              },
            },
          })
        );
        this.setStatus(this.dataset.addedMessage || '');
      } catch (error) {
        this.setStatus(error instanceof Error ? error.message : this.dataset.errorMessage || '');
      } finally {
        this.setBusy(false);
      }
    }

    async buyNow() {
      const items = this.selectedItems();
      if (!items.length || this.dataset.busy === 'true') return;

      this.setBusy(true);
      this.setStatus('');

      try {
        if (!window.JudyBuyNowCheckout?.createCheckout) throw new Error('Unable to create checkout.');
        const checkoutUrl = await window.JudyBuyNowCheckout.createCheckout({
          endpoint: this.dataset.storefrontApiUrl,
          items,
          countryCode: this.dataset.countryCode,
          languageCode: this.dataset.languageCode,
        });
        window.location.assign(checkoutUrl);
      } catch (error) {
        this.setStatus(error instanceof Error ? error.message : this.dataset.errorMessage || '');
        this.setBusy(false);
      }
    }

    async share() {
      const shareData = { title: this.dataset.productTitle || document.title, url: window.location.href };
      try {
        if (navigator.share) {
          await navigator.share(shareData);
          return;
        }
        await navigator.clipboard?.writeText(shareData.url);
        this.setStatus(this.dataset.linkCopiedMessage || '');
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return;
      }
    }

    wishlistIds() {
      try {
        const ids = JSON.parse(localStorage.getItem('judy:wishlist-products') || '[]');
        return Array.isArray(ids) ? ids.map(String) : [];
      } catch {
        return [];
      }
    }

    initializeWishlist() {
      const active = this.wishlistIds().includes(String(this.dataset.productId));
      this.querySelectorAll('[data-judy-wishlist]').forEach((button) => {
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', active ? button.dataset.removeLabel || '' : button.dataset.addLabel || '');
      });
    }

    toggleWishlist() {
      if (!this.querySelector('[data-judy-wishlist]')) return;
      const productId = String(this.dataset.productId);
      const ids = this.wishlistIds();
      const index = ids.indexOf(productId);
      if (index >= 0) ids.splice(index, 1);
      else ids.push(productId);
      try {
        localStorage.setItem('judy:wishlist-products', JSON.stringify(ids));
      } catch {
        return;
      }
      this.initializeWishlist();
    }
  }

  if (!customElements.get('judy-pdp-panel')) customElements.define('judy-pdp-panel', JudyPdpPanel);
  } catch(e) { console.error(e); }
})();

})();
